import httpService from "./http.service";

class PageBuilderRowService {
    getPageBuilderRowUrl = "/pageBuilder-row";

    getPageBuilderRow = (pageId) => {
        return httpService.get(`/pageBuilder-row/${pageId}`);
    };
    createPageBuilderRow = (model) => {
        return httpService.post("/pageBuilder-row", model, "createPageBuilderRow");
    };
    editPageBuilderRow = (id, model) => {
        return httpService.patch("/pageBuilder-row/" + id, model, "editPageBuilderRow", {}, "patch");
    };
    deletePageBuilderRow = (id) => {
        return httpService.delete("/pageBuilder-row/" + id);
    };


    createPageBuilderRowContent = (rowId, model) => {
        return httpService.form(`/pageBuilder-row/content/${rowId}`, model, "createPageBuilderRowContent");
    };
    selectGlassesPageBuilderRowContent = (rowId, model) => {
        return httpService.post(`/pageBuilder-row/content/glasses/${rowId}`, model, "createPageBuilderRowContent");
    };
    selectBrandsPageBuilderRowContent = (rowId, model) => {
        return httpService.post(`/pageBuilder-row/content/brands/${rowId}`, model, "createPageBuilderRowContent");
    };
    editPageBuilderRowContent = (rowId, index, model) => {
        return httpService.form(`/pageBuilder-row/content/${rowId}/${index}`, model, "updatePageBuilderRowContent", {}, "patch");
    };
    updatePageBuilderRowSort = (pageId, data) => {
        return httpService.patch(`/pageBuilder-row/change-order/${pageId}`, data);
    };
    deletePageBuilderRowContent = (rowId, index) => {
        return httpService.delete(`/pageBuilder-row/content/${rowId}/${index}`);
    };

}

const pageBuilderRowService = new PageBuilderRowService();
export default pageBuilderRowService;